/**
 * Infinite horizontal marquee — displays a scrolling banner of brand values.
 * Duplicates content so CSS animation can seamlessly loop.
 */

const ITEMS: { text: string; italic?: boolean }[] = [
  { text: 'GELO EM CUBO' },
  { text: '★', italic: true },
  { text: 'GELO EM ESCAMAS' },
  { text: '★', italic: true },
  { text: 'AMBULANTES DA PRAIA' },
  { text: '★', italic: true },
  { text: 'PESCADORES & BARCOS' },
  { text: '★', italic: true },
  { text: 'CONCRETAGEM' },
  { text: '★', italic: true },
  { text: 'CAIXAS TÉRMICAS PARA EVENTOS' },
  { text: '★', italic: true },
  { text: '3 LOJAS · DESDE 1989' },
  { text: '★', italic: true },
]

export function mountMarquee(): void {
  const track = document.getElementById('marquee-track') as HTMLDivElement | null
  if (!track) return

  track.innerHTML = ''

  // Render items twice for seamless loop
  const renderPass = () => {
    ITEMS.forEach((item) => {
      const span = document.createElement('span')
      span.className = 'marquee__item' + (item.italic ? ' italic' : '')
      span.textContent = item.text
      track.appendChild(span)
    })
  }
  renderPass()
  renderPass()
}
